// This file was generated with `pnpm run build:icons`. Don’t edit directly.
import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const CaretLeftSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" d="M9.953 4.023 6.048 8l3.902 3.977" />
  </IconV2>
);

export default CaretLeftSmallIcon;
